<template>
  <div :class="{ 'form-control': true, 'is-select': true }">
    <v-select
      :disabled="disabled"
      class="filter__select"
      :options="data"
      v-model="data_id"
      :reduce="reduce"
      :filterBy="filterByUsers"
      :placeholder="placeholder"
      label="name"
      @search="debouncedFetchData">
      <template
        slot="no-options"
        v-if="data.length">
        <template v-if="!emptyResults">Trwa wyszukiwanie&hellip;</template>
        <template v-if="emptyResults">Brak wyników pasujących do podanej frazy&hellip;</template>
      </template>
      <template
        slot="no-options"
        v-if="!data.length">
        <span class="font-weight-bold">Brak wyników</span>
      </template>
      <template
        slot="option"
        slot-scope="option">
        <div class="d-center">
          {{ option.name }} {{ option.last_name }}
          <span
            v-if="duration"
            style="font-weight: 100; opacity: 0.6">- Czas trwania: <span style="font-weight: 600; color: #17c671">{{option.duration.split(':')[0].length !== 1 ? (option.duration.split(':')[0] + ' minut') : (option.duration.split(':')[0] + ' h')}}</span></span>
        </div>
      </template>
      <template
        slot="selected-option"
        slot-scope="option">
        <div class="selected d-center">
          {{ option.name }} {{ option.last_name }}
        </div>
      </template>
    </v-select>
  </div>
</template>

<script>
import debounce from 'lodash.debounce';
import FormUtils from '../../utils/FormUtils.js';
import Vue from 'vue';

export default {
  name: 'filter-autocomplete',
  props: {
    dataId: {
      type: [String, Number],
      required: true
    },
    endpointItems: {
      type: String,
      required: true
    },
    endpointItem: {
      type: String,
      required: true
    },
    placeholder: {
      type: String
    },
    reduce: {
      type: Function,
      required: true
    },
    customParamsFilter: {
      type: [String, Number]
    },
    disabled: {
      type: Boolean,
      default: false
    },
    duration: {
      type: Boolean,
      default: false
    },
    skipInputEvent: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    data_id (data) {
      this.emitFilterResult(data);
    }
  },
  data () {
    return {
      data_id: null,
      data: [],
      emptyResults: false
    };
  },
  mounted () {
    this.data_id = this.dataId;
    if (this.data_id) {
      this.prefetchData(this.data_id);
    } else {
      this.data_id = null;
      let where = {
        service_id: this.customParamsFilter ? this.customParamsFilter : ''
      };
      FormUtils.loadAdditionalData(this, {
        endpoint: this.endpointItems,
        outputKey: 'data',
        params: {
          pagination: false,
          where
        },
      });
    }
  },
  methods: {
    emitFilterResult (data) {
      if (!this.skipInputEvent) {
        this.$emit('input', data);
      }
    },
    filterByUsers (option, label, search) {
      return (option.name + ' ' + option.last_name).toLowerCase().indexOf(search.toLowerCase()) > -1;
    },
    prefetchData (patientID) {
      if (!patientID) {
        return;
      }
      FormUtils.loadAdditionalData(this, {
        endpoint: this.endpointItem + parseInt(patientID, 10),
        outputKey: 'data',
        wrapResponseIntoArray: true,
        successAction: () => {
          this.data_id = parseInt(patientID, 10);
          Vue.nextTick(() => {
            this.$bus.$emit('filter-autocomplete-data-prefetched', this.skipInputEvent);
          });
        }
      });
    },
    fetchCustomers (searchPhrase, loadingCallback) {
      this.emptyResults = false;
      loadingCallback(true);

      let endpointUrl = this.endpointItems;
      let responseAsArray = false;
      let paramsData = {};

      if (searchPhrase !== '') {
        paramsData.where = {
          search: searchPhrase
        };
      }

      if (this.data_id !== 0 && this.data_id !== null && searchPhrase === '') {
        endpointUrl = this.endpointItem + parseInt(this.data_id, 10);
        responseAsArray = true;
      }

      FormUtils.loadAdditionalData(this, {
        endpoint: endpointUrl,
        outputKey: 'data',
        params: paramsData,
        wrapResponseIntoArray: responseAsArray,
        successAction: (response) => {
          if (!response.length) {
            this.emptyResults = true;
          }
          loadingCallback(false);
        }
      });
    },
    debouncedFetchData: debounce(function (searchPhrase, loadingCallback) {
      this.fetchCustomers(searchPhrase, loadingCallback);
    }, 500),
  }
};
</script>

<style lang="scss">
.filter__select {
  .vs__selected-options .vs__search {
    color: #000;
  }
}
</style>
